<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="30rem"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon small v-on="on">
        <v-icon small>fa-edit</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="space-between" no-gutters>
          <v-spacer></v-spacer>
          <v-btn small icon text @click="dialog = false" :disabled="loading">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-form
        ref="form"
        v-model="valid"
        v-if="category"
        class="mt-3"
        @submit.prevent="updateCategory"
      >
        <v-card-text class="pb-0">
          <v-text-field
            ref="nameInput"
            class="no-before"
            filled
            label="Nom de la catégorie"
            :disabled="loading"
            v-model="category.name"
            :rules="[
              v => !!v || 'Un nom est requis',
              v => v !== '' || 'Un nom est requis',
              v => v !== ' ' || 'Un nom est requis'
            ]"
          ></v-text-field>
          <v-select
            label="Type de catégorie"
            class="no-before"
            filled
            :disabled="loading"
            :items="getTagCategoryTypes"
            v-model="category.category_type"
          ></v-select>
          <v-row align="center" no-gutters v-show="loading">
            <v-progress-linear
              indeterminate
              color="primary"
            ></v-progress-linear>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row align="center" justify="end" no-gutters>
            <v-btn
              color="success"
              :disabled="!valid || loading || category === undefined"
              :block="$vuetify.breakpoint.xsOnly"
              :small="!$vuetify.breakpoint.xsOnly"
              :class="{ 'mt-3': $vuetify.breakpoint.xsOnly }"
              type="submit"
            >
              <v-icon small left>fa-save</v-icon>
              Enregistrer</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-form>
      <v-card-text v-else>
        <v-row align="center" justify="center" no-gutters>
          <v-progress-circular indeterminate></v-progress-circular>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
export default {
  name: "TagManagerEditor",
  props: {
    id: {
      required: true
    }
  },
  computed: {
    ...mapGetters(["getStoreId", "getTagCategoryTypes"])
  },
  data() {
    return {
      category: undefined,
      dialog: false,
      name: "",
      loading: false,
      valid: false
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        this.category = await api.retrieveTagCategory(this.id);
      } finally {
        this.loading = false;
      }
    },
    async updateCategory() {
      if (this.valid) {
        try {
          this.loading = true;
          await api.patchTagCategory(this.id, this.category);
          this.dialog = false;
          this.$emit("update");
          this.$refs.form.reset();
        } finally {
          this.loading = false;
        }
      }
    }
  },
  watch: {
    async dialog(v) {
      if (v === true) {
        await this.getData();
        setTimeout(() => this.$refs.nameInput.focus(), 200);
      } else {
        this.category = undefined;
      }
    }
  }
};
</script>

<style></style>
